<template>
	<div class="home" :style="homeBackgroundStyle">

		<div class="home-right-content" v-if="isLogin && !_isMobile">
			<div class="rightContent" ref="homeRightContent">
				
				<div class="bottom">
					<div class="manage">
						<Dropdown transfer @on-click="userAction">
							<div class="manage" style="max-width: 120px;overflow: hidden;" href="javascript:void(0)">
								<img class="manageIcon" v-if="user.userLogo" :src="user.userLogo" alt />
								<img class="manageIcon" v-else :src="getUserLogo()" alt />
								<Icon type="ios-arrow-down"></Icon>
							</div>
							<DropdownMenu slot="list">
								<DropdownItem name="center">我的</DropdownItem>
								<DropdownItem name="loginout">退出</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</div>
				</div>
			</div>
		</div>


		<!-- <img class="yunxing" src="../assets/image/gs_logo.jpg" alt /> -->
		<!-- <div class="yunxing" :style="{'visibility':bannerText?'':'hidden'}">{{ bannerText }}</div> -->
		<div class="home-concent">
			<div class="login-text" :class="[sysNamePositionClass, sysSignPositionClass]">
				<img v-if="sysSign" class="sysSign" :src="sysSign" alt="">
				<div class="sysName" :style="sysNameColorStyle"> {{ sysName }} </div>
			</div>
			<!-- AI估价板块 -->
			<div class="card-box valuation-box" :class="'valuation-position-' + valuationConfig.position">
				<div class="card valuation-card" @click="routePush(valuationItem)" v-if="valuationItem">
					<div class="top-title">
						<img v-if="valuationConfig.iconType === 'default'" :src="valuationItem.icon" alt="" srcset="">
						<img v-else-if="valuationConfig.iconImage" :src="valuationConfig.iconImage" alt="" srcset="">
						<div class="card-text" :style="getCardTextStyle(valuationConfig)">{{ valuationConfig.name ||
							valuationItem.name }}</div>
					</div>
				</div>
			</div>

			<!-- 数据服务板块 -->
			<div class="card-box data-box" :class="'data-position-' + dataConfig.position">
				<div class="card data-card" @click="routePush(dataItem)" v-if="dataItem">
					<div class="top-title">
						<img v-if="dataConfig.iconType === 'default'" :src="dataItem.icon" alt="" srcset="">
						<img v-else-if="dataConfig.iconImage" :src="dataConfig.iconImage" alt="" srcset="">
						<div class="card-text" :style="getCardTextStyle(dataConfig)">{{ dataConfig.name || dataItem.name
						}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import {
	newTjDk,
	newTjLp
} from "@/api/placeMarket";
import {
	queryNews,
	getBanner
} from "@/api/home";
import {
	get_model_tree
} from "@/api/router";
import {
	mapMutations,
	mapState
} from "vuex";
import {
	getObj
} from "@/api/user/user";

import {
	get_current_customer
} from "@/api/roleAndAccount";
import { getLocalAppConfig, getConfigItem } from "@/utils/appConfig";

import dataReports from "@/mixins/dataReports";
import { set } from "lodash";

export default {
	name: "home",
	mixins: [dataReports],
	filters: {
		formatDate: function (val) {
			const value = new Date(val);
			const year = value.getFullYear();
			const month = value.getMonth() + 1;
			const day = value.getDate();
			const hour = value.getHours();
			const minutes = value.getMinutes();
			const seconds = value.getSeconds();
			return (
				year +
				"-" +
				(month >= 10 ? month : "0" + month) +
				"-" +
				(day >= 10 ? day : "0" + day)
			);
		},
	},
	data() {
		return {
			sysName: '',
			sysSign: '',
			// 板块配置
			valuationConfig: {},
			dataConfig: {},
			// 默认板块数据
			valuationItem: null,
			dataItem: null,

			data: [],
			cardList: [
				{
					name: "AI估价",
					icon: require("../assets/image/aigujia.png"),
					path: "/Empowerment/pledge/houseProperty/rapidValuation",
					width: '295px',
					text: '',
					disabled: false
				},
				{
					name: "数据服务",
					icon: require("../assets/image/shujufuwu.png"),
					path: "/",
					modalName: "城市模块",
					width: '300px',
					text: '',
					disabled: false
				},

			],
			leftNavList: [{
				name: "宏观经济",
				icon: require("../assets/image/icon1.png"),
				path: "/Insight/MacroEconomy",
				modalName: "宏观模块",
				disabled: false
			},
			{
				name: "土地市场",
				icon: require("../assets/image/icon2.png"),
				path: "/Insight/land/107/iframe",
				// path: "/Insight/PlaceMarket",
				modalName: "土地模块",
				disabled: false
			},
			{
				name: "金融市场",
				icon: require("../assets/image/icon3.png"),
				path: "/Insight/financialMarket",
				modalName: "金融模块",
				disabled: false
			},
			{
				name: "城市系统",
				icon: require("../assets/image/icon4.png"),
				path: "/Insight/City",
				modalName: "城市模块",
				disabled: false
			},
			{
				name: "企业监测",
				icon: require("../assets/image/icon5.png"),
				path: "/Insight/enterprise",
				modalName: "企业模块",
				disabled: false
			},
			{
				name: "舆情监测",
				icon: require("../assets/image/icon6.png"),
				disabled: true
			},
			],
			tab: "tab1",
			rightNavList: [{
				name: "一键看项目",
				icon: require("../assets/image/icon7.png"),
				path: "/Empowerment/Analysis/Home",
				disabled: false
			},
			{
				name: "房屋智能估价",
				icon: require("../assets/image/icon8.png"),
				path: "/Empowerment/pledge/houseProperty",
				disabled: false
			},
			{
				name: "企业研究",
				icon: require("../assets/image/icon9.png"),
				disabled: true
			},
			{
				name: "城市/区位研究",
				icon: require("../assets/image/icon10.png"),
				disabled: true
			},
			{
				name: "舆情预警",
				icon: require("../assets/image/icon11.png"),
				disabled: true
			},
			],
			searchValue: "",

			searchTipsList: [],
			searchLoading: false,
			tableLoading2: false,
			tableLoading: false,
			activeNav: 0,
			current: 1,
			total: 0,
			navList: [{
				name: "城市系统",
				id: 0,
				path: "/Insight/City/stat/cityStat",
				icon: require("../assets/image/homeicon1.png"),
				icon1: require("../assets/image/homeicon11.png"),
				// modalName: "宏观模块",
			},
			{
				name: "定制",
				id: 3,
				path: "/customerorder/customerorder",
				icon: require("../assets/image/homeicon2.png"),
				icon1: require("../assets/image/homeicon22.png"),

				// modalName: "企业模块",
			},
			{
				name: "数据确权可视化",
				id: 1,
				path: "https://address.zhongsituo.com:10444/shareScreen/eyJzY3JlZW5JZCI6OX0=",
				icon: require("../assets/image/homeicon3.png"),
				icon1: require("../assets/image/homeicon33.png"),
				alink: true,
				// modalName: "土地模块",
			},

				// {
				// 	name: "舆情",
				// 	id: 4,
				// },
			],
			tip: [
				"请输入搜索的城市或指标分类",
				"请输入地块名称或地址",
				"请输入楼盘名称",
				"请输入企业名称或代码",
				"请输入搜索内容",
			],
			newsList: [],
			bannerText: ''
		};
	},
	computed: {
		...mapState([
			"userId",
			"user",
			"fixedLeft",
			"customerAccountEndDate",
			"resourceAuthIds"
		]),
		isLogin() {
			return this.$store.state.token && this.$store.state.userId;
		},
		_isMobile() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			);
			return !!flag;
		},
		showHome() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return true;
			}
			if (cachedConfig.homePage === 'true') {
				return true;
			} else {
				return false;
			}
		},
		// 系统名称位置类名
		sysNamePositionClass() {
			const appConfig = getLocalAppConfig();
			const position = appConfig?.sysNameConfig?.position || 'center';
			return `sys-name-position-${position}`;
		},
		// 系统名称颜色样式
		sysNameColorStyle() {
			const appConfig = getLocalAppConfig();
			const color = appConfig?.sysNameConfig?.color || '#002c63';
			return { color: color };
		},
		// 系统标识位置类名
		sysSignPositionClass() {
			const appConfig = getLocalAppConfig();
			const position = appConfig?.sysSignConfig?.position || 'center';
			return `sys-sign-position-${position}`;
		},
		// 首页背景图片样式
		homeBackgroundStyle() {
			const appConfig = getLocalAppConfig();
			if (!appConfig) {
				return {};
			}
			const homePageConfig = appConfig.homePageConfig;

			if (homePageConfig.bgType === 'custom') {
				// 如果配置为custom且有自定义背景图片，使用自定义背景
				return {
					backgroundImage: `url(${homePageConfig.bgImage})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					width: '100%',
					height: '100%',
					backgroundPosition: 'center -58px'
				};
			} else {
				// 如果配置为default或没有配置，使用默认背景
				return {
					// background:`url(${homePageConfig.bgImage})`,
					// background:'url(../assets/image/home_bg.png)',
					// backgroundImage: 'url(../assets/image/home_bg.png)',
					// backgroundRepeat: 'no-repeat',
					// width:'100%',
					// height:'100%',
					// backgroundSize: 'cover',
					// backgroundPosition: 'center -58px'
				};
			}
		},
	},
	methods: {
		...mapMutations(["changeState"]),
		goHome() {
			this.$router.push({
				path: "/",
			});
		},
		getUserLogo() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return require('../assets/image/userLogo.png');
			}
			if (cachedConfig.innerPageConfig.myIconType === "custom") {
				return cachedConfig.innerPageConfig.myIconImage;
			} else {
				return require('../assets/image/userLogo.png');
			}
		},
		userAction(name) {
			const action = {
				loginout: () => {
					console.log('退出登录，token1')
					this.changeState({
						prop: "token",
						value: "",
					});
					localStorage.setItem("token", "");
					localStorage.setItem("isLogin", false);
					localStorage.setItem("userId", "");
					localStorage.setItem("customerInfo", "");
					window.location.reload();
				},
				center: () => {
					this.$router.push("/PersonalCenter");
				},
			};
			action[name] && action[name]();
		},
		// 初始化首页配置
		initHomePageConfig() {
			// 从本地存储获取应用配置
			const appConfig = getLocalAppConfig();
			if (appConfig) {
				// 获取系统标识配置
				if (appConfig.sysSign) {
					this.sysSign = appConfig.sysSign;
				} else {
					this.sysSign = '';
				}

				// 获取系统名称配置
				if (appConfig.sysName) {
					this.sysName = appConfig.sysName;
				} else {
					this.sysName = 'AI估价系统';
					// //console.log('使用默认系统名称:', this.sysName);
				}

				// 初始化板块配置
				this.initCardConfigs();
			} else {
				// 如果应用配置不存在，使用默认配置
				this.sysSign = '';
				this.sysName = 'AI估价系统';
				//console.log('使用默认配置:', { sysSign: this.sysSign, sysName: this.sysName });
				this.initCardConfigs();
			}
		},
		// 初始化板块配置
		initCardConfigs() {
			const appConfig = getLocalAppConfig();
			if (!appConfig) {

				this.valuationItem = this.cardList[0]
				this.valuationConfig = {
					name: 'AI估价',
					color: '#fff',
					homeColor: '#fff',
					
					style: 'blue',
					iconType: 'default',
					iconImage: '',
					nameBgType: 'default',
					nameBgImage: '',
					position: 'left'
				};
				this.dataConfig = {
					name: '数据服务',
					color: '#fff',
					homeColor: '#fff',
					style: 'blue',
					iconType: 'default',
					iconImage: '',
					nameBgType: 'default',
					nameBgImage: '',
					position: 'right'
				};
				this.dataItem = this.cardList[1]
				return
			}
			//console.log('完整应用配置:', appConfig);

			// 获取AI估价板块配置
			if (appConfig && appConfig.sysValuationConfig) {
				this.valuationConfig = appConfig.sysValuationConfig;
				//console.log('从配置项获取AI估价板块配置:', this.valuationConfig);
				//console.log('AI估价板块位置:', this.valuationConfig.position);
			} else {
				// 使用默认配置
				this.valuationConfig = {
					name: 'AI估价',
					color: '#002c63',
					homeColor: '#fff',
					style: 'blue',
					iconType: 'default',
					iconImage: '',
					nameBgType: 'default',
					nameBgImage: '',
					position: 'left'
				};
				//console.log('使用默认AI估价板块配置:', this.valuationConfig);
			}

			// 获取数据服务板块配置
			if (appConfig && appConfig.sysDateConfig) {
				this.dataConfig = appConfig.sysDateConfig;
				//console.log('从配置项获取数据服务板块配置:', this.dataConfig);
				//console.log('数据服务板块位置:', this.dataConfig.position);
			} else {
				// 使用默认配置
				this.dataConfig = {
					name: '数据服务',
					color: '#002c63',
					homeColor: '#fff',
					style: 'blue',
					iconType: 'default',
					iconImage: '',
					nameBgType: 'default',
					nameBgImage: '',
					position: 'right'
				};
				//console.log('使用默认数据服务板块配置:', this.dataConfig);
			}

			// 设置默认板块数据
			if (appConfig.sysValuation === 'true') {
				this.valuationItem = this.cardList[0]
			} else {
				this.valuationItem = null
			}
			if (appConfig.sysDate === 'true') {
				this.dataItem = this.cardList[1]
			} else {
				this.dataItem = null
			}

			// console.log('最终板块配置:', {
			// 	valuation: this.valuationConfig,
			// 	data: this.dataConfig
			// });
		},
		// 获取卡片文字样式
		getCardTextStyle(config) {
			const style = {};

			// 设置颜色
			if (config.homeColor) {
				style.color = config.homeColor;
			}

			// 设置背景
			if (config.nameBgType === 'default') {
				// 使用默认背景样式
				style.background = 'linear-gradient(90deg, rgba(133, 236, 255, 0) 0%, #045AFC 48%, rgba(131, 234, 255, 0) 100%)';
			} else if (config.nameBgImage) {
				// 使用自定义背景图片
				style.background = `url(${config.nameBgImage})`;
				style.backgroundSize = 'cover';
				style.backgroundPosition = 'center';
				style.backgroundRepeat = 'no-repeat';
			}

			return style;
		},
		getUserInfo() {
			if (localStorage.getItem("userId")) {
				getObj({
					id: localStorage.getItem("userId"),
				}).then((res) => {
					this.changeState({
						prop: "user",
						value: res,
					});
				});
			} else {
				this.$router.push({
					path: "/login",
				});
			}
		},
		async getCustomer() {
			let data = await get_current_customer()
			localStorage.setItem("customerInfo", JSON.stringify(data));
		},
		_load_news() {
			queryNews({
				current: 0,
				size: 9,
				contType: 4
			}).then((res) => {
				this.newsList = res.records;
			});
		},
		getBanner() {
			getBanner({
				origin: 1
			}).then((res) => {
				this.bannerText = res.text
			})
		},
		gotoDetail(item) {
			this.$router.push({
				path: `/Insight/City/search/buildingDetail`,
				query: {
					id: item.id,
					type: 0,
				},
			});
		},
		tableClick(info) {
			this.$router.push({
				path: `/Insight/PlaceDetail`,
				query: {
					id: info.id,
					type: "option",
					methods: 3,
				},
			});
		},
		tab1(page) {
			this.current = page;
			this.tabData1(1);
		},
		tab2(page) {
			this.current = page;
			this.tabData1(2);
		},
		tabData1(type) {
			if (type == 1) {
				this.tableLoading = true;
				newTjDk({
					size: 5,
					current: this.current,
					type: type,
				})
					.then((data) => {
						this.total = data.total;
						this.data = data.records;
					})
					.finally(() => {
						this.tableLoading = false;
					});
			} else if (type == 2) {
				this.tableLoading2 = true;
				newTjLp({
					size: 5,
					current: this.current,
					type: type,
				})
					.then((data) => {
						this.total = data.total;
						this.data = data.records;
					})
					.finally(() => {
						this.tableLoading2 = false;
					});
			}
		},
		onTab(obj) {
			this.current = 1;
			this.total = 0;
			if (obj == "tab1") {
				this.tabData1(1);
			} else {
				this.tabData1(2);
			}
		},
		searchHandle(item) {
			this.searchLoading = true;
			if (this.activeNav == 1) {
				if (item && item.key == "地块地址") {
					this.$router.push({
						path: `/Insight/land/listSearch`,
						query: {
							searchVal2: this.searchValue,
						},
					});
					return;
				}
				this.$router.push({
					path: `/Insight/land/listSearch`,
					query: {
						searchVal: this.searchValue,
					},
				});
			} else if (this.activeNav == 2) {
				this.$router.push({
					path: `/Insight/City/search/buildingSearch`,
					query: {
						searchVal: this.searchValue,
					},
				});
			} else if (this.activeNav == 0) {
				if (item && item.key == "城市") {
					this.$router.push({
						path: `/Insight/MacroEconomy/EconomicStatistics/DataSearch`,
						query: {
							city: this.searchValue,
						},
					});
				} else {
					this.$router.push({
						path: `/Insight/MacroEconomy/EconomicStatistics/DataSearch`,
						query: {
							searchVal: this.searchValue,
						},
					});
				}
			} else if (this.activeNav == 3) {
				this.$router.push({
					path: `/Insight/enterprise/enterpriseHome/enterpriseSearch`,
					query: {
						searchVal: this.searchValue,
					},
				});
			} else if (this.activeNav == 4) {
				this.$router.push({
					path: "/Insight/publicSentiment/hotspot",
					query: {
						searchVal: this.searchValue,
					},
				});
			}
			this.searchLoading = false;
		},
		changeNav(item) {


		},
		changeValue() {
			if (this.activeNav == 0) {
				this.searchValue &&
					(this.searchTipsList = [{
						key: "指标分类",
						item: [this.searchValue],
					},
					{
						key: "城市",
						item: [this.searchValue],
					},
					]);
				!this.searchValue && (this.searchTipsList = []);
			} else if (this.activeNav == 1) {
				this.searchValue &&
					(this.searchTipsList = [{
						key: "地块名称",
						item: [this.searchValue],
					},
					{
						key: "地块地址",
						item: [this.searchValue],
					},
					]);
				!this.searchValue && (this.searchTipsList = []);
			} else if (this.activeNav == 2) {
				this.searchValue &&
					(this.searchTipsList = [{
						key: "楼盘名称",
						item: [this.searchValue],
					},]);
				!this.searchValue && (this.searchTipsList = []);
			} else if (this.activeNav == 3) {
				this.searchValue &&
					(this.searchTipsList = [{
						key: "企业名称或代码",
						item: [this.searchValue],
					},]);
				!this.searchValue && (this.searchTipsList = []);
			} else if (this.activeNav == 4) {
				this.searchValue &&
					(this.searchTipsList = [{
						key: "关键字",
						item: [this.searchValue],
					},]);
				!this.searchValue && (this.searchTipsList = []);
			}
		},
		routePush(item) {
			if (item.alink) {
				window.open(item.path, "_blank");
				return
			}
			if (item.path) {
				if (item.modalName) {
					this.changeState({
						prop: "actionRouter",
						value: [],
					});
					get_model_tree({
						modelName: item.modalName,
					}).then((res) => {
						let actionRouter = [];
						res.children.map((item) => {
							let i = {
								url: location.protocol + "//" + location.host + item
									.fineReportUrl,
								title: item.indexName,
								children: [],
								icon: "ios-eye",
							};
							if (item.children) {
								item.children.map((item) => {
									i.children.push({
										url: location.protocol +
											"//" +
											location.host +
											item.fineReportUrl,
										title: item.indexName,
									});
								});
							}
							actionRouter.push(i);
						});
						this.changeState({
							prop: "actionRouter",
							value: actionRouter,
						});
						localStorage.setItem("actionRouter", JSON.stringify(actionRouter));
						if (res.children[0].fineReportUrl) {
							this.changeState({
								prop: "iframeUrl",
								value: location.protocol +
									"//" +
									location.host +
									res.children[0].fineReportUrl,
							});
							localStorage.setItem(
								"iframeUrl",
								location.protocol +
								"//" +
								location.host +
								res.children[0].fineReportUrl
							);
						} else {
							this.changeState({
								prop: "iframeUrl",
								value: "",
							});
							localStorage.setItem("iframeUrl", "");
						}
						this.$router.push(item.path);
					});
				} else {
					this.changeState({
						prop: "actionRouter",
						value: "",
					});
					localStorage.setItem("actionRouter", "");
					this.changeState({
						prop: "iframeUrl",
						value: "",
					});
					localStorage.setItem("iframeUrl", "");
					this.$router.push(item.path);
				}
			} else {
				this.$msg.error({
					type: "noAuthority",
					code: 1007,
				});
			}
		},
	},
	mounted() {
		// 初始化首页配置
		setTimeout(() => {
			this.initHomePageConfig();

		}, 1000);
		this.tabData1(1);
		this._load_news();
		this.getUserInfo();
		this.getCustomer()
		this.getBanner()
		this.$nextTick(() => {
			// document.getElementsByClassName('searchBtn')[0].addEventListener('click', () => { this.$btnSysLog(1, 0, { pageId: 1, pageName: '首页' }) })
		})
	},
};
</script>


<style lang="scss" scoped>
@import "@/style/common.scss";

.home {
	width: 100%;
	height: 100%;
	padding-top: 28px;
	box-sizing: border-box;
	background: #f8fafb;
	overflow: auto;
	width: 100%;
	// height: 100%;
	height: 100vh;
	background-size: 100%;
	background-image: url(../assets/image/home_bg.png);
	background-repeat: no-repeat;
	overflow: hidden;
	background-size: cover;
	background-position-y: -58px;

	.home-right-content {
		display: flex;
		justify-content: flex-end;
		// padding: 20px 48px 0 48px;
		height: 16px;
		.rightContent {
		width: 300px;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		white-space: norwap;
		font-size: 18px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #262626;
		justify-content: flex-end;

		.line {
			width: 1px;
			height: 40px;
			background: rgba(0, 0, 0, 0.15);
		}

		.officialWebsite {
			// @include flex-center;
			margin-left: 40px;
			// margin: 0 40px;
			white-space: nowrap;
			cursor: pointer;

			a {
				color: #262626;
			}

			&:hover {
				color: #262626;
			}
		}

		.top,
		.bottom {
			height: 45%;
			display: flex;
			align-items: center;
			white-space: norwap;
			// width: 100%;
		}


		.tradingPlatform {
			@include flex-center;
			color: #fff;
			margin-right: 40px;
			white-space: nowrap;
			cursor: pointer;

			&:hover {
				color: #eee;
			}

			img {
				margin-right: 6px;
			}
		}

		.infoTips {
			position: relative;
			cursor: pointer;
			margin-left: 43px;
			margin-right: 26px;

			img {
				display: block;
				width: 14px;
				height: 16px;
			}

			.infoNumber {
				position: absolute;
				width: 14px;
				height: 14px;
				background: rgba(245, 44, 43, 1);
				border-radius: 50%;
				font-size: 12px;
				font-family: PingFangSC-Regular-, PingFangSC-Regular;
				font-weight: normal;
				color: #FFFFFF;
				// color: #ffffff;
				top: -9px;
				right: -9px;
				@include flex-center;
			}

			.bigNum {
				height: 16px;
				width: 28px;
				border-radius: 25px;
				top: -9px;
				right: -24px;
			}
		}

		.manage {
			@include flex-center;
			font-size: 14px;
			// color: #ffffff;
			font-family: ArialMT-, ArialMT;
			justify-content: left;
			cursor: pointer;
			white-space: nowrap;
			// width: 140px;
			width: 80px;
			margin-top: 10px;
			.manageIcon {
				width: 36px;
				height: 36px;
				border-radius: 50%;
				margin-right: 8px;
				// background: #000;
			}

			.downIcon {
				margin-left: 6px;
			}
		}

		.fullScreen {
			cursor: pointer;
			position: absolute;
			right: 27px;
			bottom: 18px;
		}

		.logoA {
			white-space: nowrap;
			transform: translate(0px, 0px);
			display: flex;
			align-items: center;
			// color: #fff;
		}

		.logo2 {
			width: 20px;
			height: 20px;
			margin-right: 3px;
		}
	}
	}

	.home-concent {
		// margin-left: 190px;
		// display: flex;

		.home-title {
			margin-top: 206px;
			margin-bottom: 56px;
			width: 336px;
			height: 67px;
			font-size: 48px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #045AFC;
			line-height: 0px;
		}
	}

	.yunxing {
		// margin: 0 auto 50px;
		// display: block;
		display: inline-block;
		display: table;
		margin-top: 20px;
		margin-left: 20px;
		// min-width: 900px;
		width: 200px;
		padding: 0 10px;
		// height: 60px;
		font-size: 32px;
		color: white;
		line-height: 60px;
		text-align: center;
		border-radius: 8px;
		font-weight: 900;
		font-family: "SimSun";
	}

	.navList {
		// width: 480px;
		// height: 20px;
		display: flex;
		// justify-content: space-between;
		align-items: center;
		// margin: 0 auto;

		.navItem {
			font-family: PingFang SC;
			font-size: 24px;
			font-weight: normal;
			height: 62px;
			line-height: 62px;
			border-radius: 4px;
			background: rgba(0, 119, 255, 0.09);
			color: #045AFC;
			backdrop-filter: blur(7px);
			margin-right: 24px;
			padding: 0 22px;
			display: flex;
			align-items: center;
			cursor: pointer;

			&:last-of-type {
				margin-right: 0;
			}

			&:hover {
				color: #ffffff;
				background-color: #045AFC;
			}

			//前面加图标
			&::before {
				content: "";
				display: inline-block;
				width: 24px;
				height: 24px;
				margin-right: 10px;
				background-size: 100%;
				background-repeat: no-repeat;
				// background-image: url(../assets/image/homeicon1.png);

			}

			&.active {
				// color: #616dff;
				color: #045AFC;
				// position: relative;
				// font-weight: bold;
				// width:  92px;
				// height: 62px;
				background-size: 100%;
				background-image: url(../assets/image/home-selice.png);
				background-repeat: no-repeat;


			}
		}

		.navItemicon1 {
			&::before {
				content: "";
				display: inline-block;
				width: 30px;
				height: 30px;
				margin-right: 10px;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				background-image: url(../assets/image/homeicon1.png);
			}

			&:hover::before {
				background-image: url(../assets/image/homeicon11.png); // 悬停时的图片路径
			}
		}

		.navItemicon2 {
			&::before {
				content: "";
				display: inline-block;
				width: 30px;
				height: 30px;
				margin-right: 10px;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				background-image: url(../assets/image/homeicon2.png);
			}

			&:hover::before {
				background-image: url(../assets/image/homeicon22.png); // 悬停时的图片路径
			}
		}

		.navItemicon3 {
			&::before {
				content: "";
				display: inline-block;
				width: 30px;
				height: 30px;
				margin-right: 10px;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				background-image: url(../assets/image/homeicon3.png);
			}

			&:hover::before {
				background-image: url(../assets/image/homeicon33.png); // 悬停时的图片路径
			}
		}
	}

	.searchTab {
		width: 993px;
		// height: 76px;
		// background: #fff;
		display: flex;
		align-items: center;
		// margin: 42px auto 0;
		margin-top: 48px;
		position: relative;
		// box-shadow: 0 10px 20px 0 rgba(41, 53, 92, 0.1);
		// border-radius: 38px;

		font-family: PingFang SC-Light, PingFang SC;

		.searchInput {

			// border-left: 1px solid #e8e8e8;
			outline: none;
			box-sizing: border-box;
			padding: 0 10px;
			font-size: 20px;
			text-indent: 12px;
			// border-radius: 38px 0 0 38px;
			background-color: transparent;
			width: 807px;
			height: 62px;
			border: 1px solid #045AFC;
		}

		.searchBtn {
			width: 167px;
			height: 76px;
			background: #616dff;
			box-shadow: 0px 0px 12px 0px rgba(41, 53, 92, 0.2);
			border-radius: 0px 38px 38px 0px;
			font-size: 20px;
		}

		.searchTipsBox {
			width: 807px;
			position: absolute;
			top: 66px;
			// left: 38px;
			background: #fff;
			box-shadow: 0px 0px 10px 1px rgba(0, 119, 255, 0.2);

			.searchTipsItem {
				width: 100%;
				height: 62px;
				display: flex;
				align-items: center;
				padding: 16px 5px 16px;
				box-sizing: border-box;
				cursor: pointer;
				font-size: 20px;
				font-family: PingFang SC-Light, PingFang SC;
				color: #262626;

				&:hover {
					background: #cce3ff;
					// opacity: 0.09;
				}

				.searchTipsTitle {
					height: 28px;
					background: rgba(67, 115, 232, 1);
					border-radius: 5px;
					box-sizing: border-box;
					padding: 8px 12px;
					font-size: 14px;
					@include flex-center;
					color: #fff;
				}

				.key {
					// font-size: 14px;
					// color: #666666;
					margin-left: 17px;
				}

				.item {
					// color: #333333;
					// font-size: 14px;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}

	.login-text {
		text-align: center;
		font-family: Alimama ShuHeiTi;
		font-weight: bold;
		font-size: 36px;
		color: #002C63;
		line-height: 43px;
		padding: 44px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;

		.sysName {
			position: absolute;
			z-index: 2;
		}

		.sysSign {
			position: absolute;
			z-index: 3; // 层级优先级
			max-height: 60px;
			max-width: 200px;
		}

		// 系统名称位置控制
		&.sys-name-position-left .sysName {
			left: 44px;
		}

		&.sys-name-position-center .sysName {
			left: 50%;
			transform: translateX(-50%);
		}

		&.sys-name-position-right .sysName {
			right: 44px;
		}

		// 系统标识位置控制
		&.sys-sign-position-left .sysSign {
			left: 44px;
		}

		&.sys-sign-position-center .sysSign {
			left: 50%;
			transform: translateX(-50%);
		}

		&.sys-sign-position-right .sysSign {
			right: 44px;
		}

		// 当sysName和sysSign位置一致时的处理
		// sysSign在左，sysName在右
		&.sys-name-position-left.sys-sign-position-left {
			.sysSign {
				left: 44px;
			}

			.sysName {
				left: 44px;
				margin-left: 80px; // sysSign在左，sysName在右
			}
		}

		&.sys-name-position-center.sys-sign-position-center {
			.sysSign {
				left: 50%;
				transform: translateX(-120px); // sysSign在左
			}

			.sysName {
				left: 46%;
				transform: translateX(20px); // sysName在右
			}
		}

		&.sys-name-position-right.sys-sign-position-right {
			.sysSign {
				right: 44px;
				margin-right: 220px; // sysSign在左
			}

			.sysName {
				right: 44px; // sysName在右
			}
		}
	}

	.card-box {
		position: absolute;
		margin-top: 70px;

		// AI估价板块位置控制
		&.valuation-position-left {
			left: 19.17vw; // 368px / 1920px ≈ 19.17vw，响应式适配
		}

		&.valuation-position-center {
			left: 50%;
			transform: translateX(-50%);
		}

		&.valuation-position-right {
			right: 19.17vw; // 368px / 1920px ≈ 19.17vw，响应式适配
		}

		// 数据服务板块位置控制
		&.data-position-left {
			left: 19.17vw; // 368px / 1920px ≈ 19.17vw，响应式适配
		}

		&.data-position-center {
			left: 50%;
			transform: translateX(-50%);
		}

		&.data-position-right {
			right: 19.17vw; // 368px / 1920px ≈ 19.17vw，响应式适配
		}
	}

	.card {
		// 移除固定宽度，让图片多宽就多宽
		// width: 420px;
		// height: 183px;
		// margin-right: 140px;
		// margin-left: 140px;
		// background: linear-gradient(181deg, #CBE3FF 0%, #FFFFFF 100%);
		opacity: 1;
		// border: 2px solid #FFFFFF;
		font-size: 26px;
		font-family: PingFang SC-Light, PingFang SC;
		// font-weight: 300;
		color: #262626;
		// line-height: 0px;
		// display: flex;
		// align-items: center;
		// flex-direction: column;
		cursor: pointer;



		img {
			// margin: 0 20px 0 32px;
			margin-bottom: 20px;
		}

		.top-title {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: 34px;
			margin-bottom: 22px;
			width: 400px;

			img {
				width: 100%;

			}
		}

		.card-text {
			text-align: center;
			font-family: Source Han Sans CN;
			font-weight: bold;
			font-size: 40px;
			color: #FFFFFF;
			line-height: 60px;
			width: 266px;
			height: 60px;
			background: linear-gradient(90deg, rgba(133, 236, 255, 0) 0%, #045AFC 48%, rgba(131, 234, 255, 0) 100%);
		}

		// flex-direction: column;
	}
}

.notice {
	display: flex;
	font-size: 24px;
	font-family: PingFang SC-Light, PingFang SC;
	// font-weight: 300;
	margin-top: 40px;
	color: #FF5858;
	align-items: center;

	img {

		margin-right: 14px;
	}
}

.content {
	display: flex;
	width: 100%;
	margin-top: 54px;

	.leftContent,
	.rightContent {
		flex: 4;
		padding: 0 27px 20px;
		box-sizing: border-box;

		.topNav {
			width: 100%;
			display: flex;
			box-shadow: 0px 10px 20px 0px rgba(41, 53, 92, 0.1);
			border-radius: 6px;
			height: 186px;

			.navitem {
				flex: 1;
				height: 100%;
				cursor: pointer;

				.disabled {
					filter: grayscale(100%);
				}

				img {
					display: block;
					width: 64px;
					height: 64px;
					margin: 41px auto 23px;
				}

				.itemName {
					text-align: center;
				}
			}
		}

		.bottomContent {
			height: 430px;
			width: 100%;
			overflow: auto;
			margin-top: 30px;
			box-shadow: 0px 10px 20px 0px rgba(41, 53, 92, 0.1);
			border-radius: 6px;
			box-sizing: border-box;
			padding: 25px;

			.bottomTitle {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 18px;
				color: #333333;
				font-weight: 500;
				font-family: Source Han Sans CN;
			}

			.bottomTabList {
				color: #999999;
				font-size: 16px;
				font-weight: 500;
				display: flex;
				margin-top: 40px;

				.bottomTabItem {
					position: relative;
					margin-right: 60px;
					transition: 0.3s;
					cursor: pointer;

					&:hover,
					&.active {
						color: #6b5af4;

						&::after {
							content: "";
							width: 36px;
							height: 2px;
							background: #6b5af4;
							position: absolute;
							bottom: -15px;
							left: calc(50% - 18px);
						}
					}
				}
			}

			.itemContent {
				width: 100%;
				height: calc(100% - 30px);
				overflow: auto;
			}

			.item {
				width: 100%;
				height: 82px;
				border-bottom: 1px solid #d6d7d9;
				position: relative;
				cursor: pointer;

				.info {
					font-size: 16px;
					color: #333333;
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					position: absolute;
					top: 13px;
					left: 0;
				}

				.time {
					color: #999999;
					position: absolute;
					top: 51px;
					left: 0;
				}

				.num {
					color: #999999;
					position: absolute;
					top: 51px;
					left: 117px;
				}

				.from {
					padding: 0 10px;
					width: auto;
					line-height: 24px;
					height: 24px;
					background: rgba(239, 245, 255, 1);
					border: 1px solid rgba(21, 98, 214, 1);
					border-radius: 2px;
					position: absolute;
					color: #1562d6;
					top: 51px;
					left: 256px;
				}
			}
		}
	}

	.leftContent {
		flex: 5;
		padding-right: 3px;
	}
}
</style>
